import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "lib/utils"

type ProgressSegment = {
  value: number
  color: string
}

type ProgressProps = React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
  segments?: ProgressSegment[]
}

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value, segments, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "tw-relative tw-h-2 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-primary/20 tw-flex",
      className
    )}
    {...props}
  >
    {segments ? (
      segments.map((segment, index) => (
        <div
          key={index}
          className="tw-h-full tw-transition-all"
          style={{ width: `${segment.value}%`, backgroundColor: segment.color }}
        />
      ))
    ) : (
      <ProgressPrimitive.Indicator
        className="tw-h-full tw-w-full tw-flex-1 tw-bg-primary tw-transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    )}
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
